import { LayoutAlternative } from '@thive/fddm-types';

import { fieldSortFunction, dateStringComparator, stringComparator } from '../sortingMenu/helpers';
import { sortingCriteriaToModelFieldMap, Order, SortingCriteria } from '../sortingMenu/constants';

export const calcSortedAlternatives = (
  layoutAlternatives: LayoutAlternative[],
  criteria: SortingCriteria,
  order: Order,
): LayoutAlternative[] => {
  const field = sortingCriteriaToModelFieldMap[criteria];
  // pls fix me
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  let sorter: any;
  if (field === 'created' || field === 'lastModified')
    sorter = fieldSortFunction(field, order, dateStringComparator);
  else sorter = fieldSortFunction(field, order, stringComparator);

  return [...layoutAlternatives].sort(sorter);
};
